import React from "react";

export default function Proposals() {
  return (
    <div className="page">
      <h1>Business Proposals for Startups</h1>
      <p>Startup proposal services placeholder.</p>
    </div>
  );
}
